import { render, staticRenderFns } from "./registerModal.vue?vue&type=template&id=1290620f&scoped=true&"
import script from "./registerModal.vue?vue&type=script&lang=js&"
export * from "./registerModal.vue?vue&type=script&lang=js&"
import style0 from "./registerModal.vue?vue&type=style&index=0&id=1290620f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1290620f",
  null
  
)

export default component.exports